import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i149901615__a)" }, [
      _createElementVNode("path", {
        fill: "#000",
        d: "M0 16c0 6.552 3.94 12.18 9.577 14.655-.045-1.117-.008-2.458.279-3.674.308-1.299 2.059-8.719 2.059-8.719s-.511-1.021-.511-2.531c0-2.371 1.374-4.142 3.085-4.142 1.456 0 2.159 1.093 2.159 2.402 0 1.463-.933 3.651-1.413 5.678-.401 1.698.85 3.082 2.525 3.082 3.032 0 5.073-3.894 5.073-8.507 0-3.507-2.361-6.131-6.657-6.131-4.854 0-7.877 3.62-7.877 7.662 0 1.394.41 2.377 1.054 3.138.296.35.337.49.23.892-.076.294-.253 1.003-.326 1.284-.106.405-.435.55-.8.4-2.236-.912-3.278-3.36-3.278-6.112 0-4.545 3.834-9.995 11.436-9.995 6.109 0 10.13 4.42 10.13 9.165 0 6.277-3.49 10.966-8.634 10.966-1.727 0-3.352-.934-3.909-1.994 0 0-.929 3.686-1.126 4.398-.339 1.234-1.003 2.467-1.61 3.428 1.472.435 3 .656 4.535.656 8.835 0 16-7.164 16-16S24.835 0 16 0C7.164 0 0 7.164 0 16"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i149901615__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h32v32H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }